import React from 'react';


export default ({label, value}) =>
  <div className="w-100">
    <div className="text-left text-muted" style={{ textTransform: "uppercase", fontSize: "small"}}>{label}</div>
    <div className="text-left">{value}</div>
  </div>;